import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { Destroy } from '@web-bankir/ui-kit/helpers/abstractions';
import { filter, startWith, takeUntil, tap, map } from 'rxjs/operators';

var RouteOutletType;
(function (RouteOutletType) {
    RouteOutletType["Primary"] = "primary";
    RouteOutletType["Modal"] = "modal";
})(RouteOutletType || (RouteOutletType = {}));

const ROUTE_SERVICE_OUTLET = new InjectionToken('ROUTE_SERVICE_OUTLET');

class RouteService extends Destroy {
    constructor(routeOutlet, router) {
        super();
        this.routeOutlet = routeOutlet;
        this.router = router;
        this.routeData = new BehaviorSubject({});
        this.routeParams = new BehaviorSubject({});
        this.outlet = this.routeOutlet ? this.routeOutlet : RouteOutletType.Primary;
        this.router.events.pipe(filter(event => event instanceof NavigationEnd), startWith(this.router), takeUntil(this.destroy$), tap(event => {
            const root = this.router.routerState.snapshot.root;
            const routeData = this.deepTree(root, this.outlet);
            if (routeData) {
                this.routeData.next(routeData.data);
                this.routeParams.next(routeData.params);
            }
        })).subscribe();
        this.isModal = this.routeData.pipe(map((data) => !!data.modal));
    }
    deepTree(root, outlet) {
        let routeData = {
            data: {},
            params: {},
        };
        let route = root.children.find((child) => child.outlet === outlet);
        const queue = (this.router.parseUrl(this.router.url).root.children[outlet]?.segments || []).map((segment) => segment.path);
        if (outlet !== RouteOutletType.Primary) {
            queue.shift();
        }
        while (route) {
            routeData = {
                data: {
                    ...routeData.data,
                    ...route.data,
                },
                params: {
                    ...routeData.params,
                    ...route.params,
                },
            };
            if (queue.length) {
                for (const url of route.url) {
                    if (url.path === queue[0]) {
                        queue.shift();
                    }
                }
            }
            route = route.firstChild;
        }
        return !queue.length ? routeData : void (0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouteService, deps: [{ token: ROUTE_SERVICE_OUTLET, optional: true }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouteService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: RouteOutletType, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ROUTE_SERVICE_OUTLET]
                }] }, { type: i1.Router }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ROUTE_SERVICE_OUTLET, RouteOutletType, RouteService };
